import { ENV } from '@/lib/config/env';

/**
 * Frontend-only entry (opens Projects in another tab). Not an API agent — labels stay local until
 * a backend agent or customization endpoint exists.
 */
// eslint-disable-next-line i18next/no-literal-string -- agent id, matched by the backend shortcut allow-list; the rendered title comes from a separate lookup
export const ADAPTATION_AGENT_ID = 'Adaptation';

/**
 * Opens the Adaptation tool in a new browser tab.
 */
export const openAdaptationTool = (workspaceSlug: string): void => {
  window.open(`${ENV.PLATFORM_BASE_URL}/${workspaceSlug}/projects`, '_blank');
};
